import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false
}

export const botImpactGraphReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_BOT_IMPACT_GRAPH_DATA:
            return {
                ...state,
                data: action.payload,
            }
        case actionTypes.SET_IMPACT_GRAPH_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_IMPACT_GRAPH_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 